import React from 'react'
import { CircularProgress, Grid, Typography } from '@mui/material'

export const LoadingMaestro = ({ label = 'Cargando datos...' }) => (
    <Grid
        container
        direction="column"
        size={{ xs: 12 }}
        sx={{
            justifyContent: "center",
            alignItems: "center",
            minHeight: 220,
            gap: 2,
        }}
    >
        <CircularProgress color="primary" />
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {label}
        </Typography>
    </Grid>
)
